import React from 'react';
import { Table } from 'semantic-ui-react';

const STATUS_MAP = {
    0: 'PENDING',
    1: 'PROCESSING',
    2: 'FAILED',
    3: 'SUCCESS',
}

const parseResponse = (jsonText) => {
    const data = JSON.parse(jsonText);
    let emails = data.map((d) => d.email).join(', ');
    if (emails.length > 50) {
        emails = emails.slice(0,50) + '...';
    }
    return emails;
}

const TableItem = ({ data, onResponseClick }) => (
    <Table.Row>
        <Table.Cell>
            {data.id}
        </Table.Cell>
        <Table.Cell>
            {data.type}
        </Table.Cell>
        <Table.Cell>
            {data.file_name}
        </Table.Cell>
        <Table.Cell>
            {data.file_path}
        </Table.Cell>
        <Table.Cell>
            {data.created_at ? data.created_at : '-'}
        </Table.Cell>
        <Table.Cell>
            {STATUS_MAP[data.status]}
        </Table.Cell>
        <Table.Cell>
            <a href='#' onClick={() => onResponseClick(data.response)}>
                {data.response ? parseResponse(data.response) : '-'}
            </a>
        </Table.Cell>
    </Table.Row>
)

export default TableItem;